export const allOrderTypes = [
  {
    name: "loanPayoff",
    label: "Loan Payoff",
    financedOnly: true,
    ownedOnly: false
  },
  {
    name: "letterOfGuarantee",
    label: "Letter of Guarantee",
    financedOnly: true,
    ownedOnly: false
  },
  {
    name: "copyOfTitle",
    label: "Title Image",
    alias: "Copy of Title",
    financedOnly: true,
    ownedOnly: false
  },
  {
    name: "titleStatus",
    label: "Title Status",
    financedOnly: true,
    ownedOnly: false
  },
  {
    name: "lienLetter",
    label: "Lien Release Letter",
    financedOnly: true,
    ownedOnly: false
  },
  {
    name: "installmentContract",
    label: "Installment Contract",
    financedOnly: true,
    ownedOnly: false
  },
  {
    name: "billOfSale",
    label: "Bill of Sale",
    financedOnly: true,
    ownedOnly: false
  },
  {
    name: "paymentHistory",
    label: "Payment History",
    financedOnly: true,
    ownedOnly: false
  },
  {
    name: "repoAffidavit",
    label: "Repo Affidavit",
    financedOnly: true,
    ownedOnly: false
  },
  {
    name: "oneAndTheSameLetter",
    label: "One and the Same Letter",
    financedOnly: true,
    ownedOnly: false
  },
  {
    name: "paymentStatus",
    label: "Payment Status",
    financedOnly: true,
    ownedOnly: false
  },
  {
    name: "w9",
    label: "W-9",
    financedOnly: true,
    ownedOnly: false
  },
  {
    name: "taxExemptLetter",
    label: "Tax Exempt Letter",
    financedOnly: true,
    ownedOnly: false
  },
  {
    name: "xTitle",
    label: "Title Transfer",
    financedOnly: false,
    ownedOnly: false
  }
];

export const requirementsMatrix = {
  allBasic: ["accountNumber", "lender", "claimNumber", "vin", "financeType"],
  allFull: [
    "causeOfLoss",
    "dateOfLoss",
    "settlementAmount",
    "deductible",
    "ownersName",
    "ownersEmailAddress",
    "ownersPhoneNumber",
    "ownersAddress",
    "vehicle.year",
    "odometer",
    "titleRemittanceAddress",
    "odometerReadingDate",
    "damages",
    "titleBrand",
    "titleType",
    "titleTransferDate",
    "titleNumber",
    "acquiringPartyMailingAddress",
    "disposingPartyName",
    "disposingPartyAddress",
    "vehicleLocation"
  ],
  loanPayoff: {
    requiredData: [
      "lenderName",
      "claimNumber",
      "causeOfLoss",
      "dateOfLoss",
      "odometer",
      "settlementAmount",
      "deductible",
      "titleRemittanceAddress",
      "vin",
      "currentVehicleLocation",
      "financeType",
      "ownersName"
    ],
    optionalData: [
      "accountNumber",
      "ownersPhoneNumber",
      "ownersAddress",
      "ownersEmailAddress"
    ]
  },
  letterOfGuarantee: {
    requiredData: [
      "lenderName",
      "claimNumber",
      "causeOfLoss",
      "dateOfLoss",
      "settlementAmount",
      "deductible",
      "titleRemittanceAddress",
      "thirdPartyClaim",
      "titleRemittanceAddress",
      "vin",
      "odometer",
      "currentVehicleLocation",
      "financeType",
      "ownersName",
      "ownersPhoneNumber",
      "ownersAddress"
    ],
    optionalData: ["accountNumber", "ownersEmailAddress"]
  },
  copyOfTitle: {
    requiredData: [
      "lenderName",
      "claimNumber",
      "causeOfLoss",
      "dateOfLoss",
      "vin",
      "financeType",
      "accountNumber",
      "ownersName",
      "ownersPhoneNumber",
      "ownersAddress"
    ],
    optionalData: ["ownersEmailAddress"]
  },
  titleStatus: {
    requiredData: [
      "lenderName",
      "claimNumber",
      "causeOfLoss",
      "dateOfLoss",
      "titleRemittanceAddress",
      "vin",
      "financeType",
      "accountNumber",
      "ownersName",
      "ownersPhoneNumber",
      "ownersAddress"
    ],
    optionalData: ["ownersEmailAddress"]
  },
  lienLetter: {
    requiredData: [
      "lenderName",
      "claimNumber",
      "causeOfLoss",
      "dateOfLoss",
      "vin",
      "financeType",
      "accountNumber",
      "ownersName",
      "ownersPhoneNumber",
      "ownersAddress"
    ],
    optionalData: ["ownersEmailAddress"]
  },
  installmentContract: {
    requiredData: [
      "lenderName",
      "claimNumber",
      "causeOfLoss",
      "dateOfLoss",
      "vin",
      "financeType",
      "accountNumber",
      "ownersName",
      "ownersPhoneNumber",
      "ownersAddress"
    ],
    optionalData: ["ownersEmailAddress"]
  },
  billOfSale: {
    requiredData: [
      "lenderName",
      "claimNumber",
      "causeOfLoss",
      "dateOfLoss",
      "vin",
      "financeType",
      "accountNumber",
      "ownersName",
      "ownersPhoneNumber",
      "ownersAddress"
    ],
    optionalData: ["ownersEmailAddress"]
  },
  paymentHistory: {
    requiredData: [
      "lenderName",
      "claimNumber",
      "causeOfLoss",
      "dateOfLoss",
      "vin",
      "financeType",
      "accountNumber",
      "ownersName",
      "ownersPhoneNumber",
      "ownersAddress"
    ],
    optionalData: ["ownersEmailAddress"]
  },
  repoAffidavit: {
    requiredData: [
      "lenderName",
      "claimNumber",
      "causeOfLoss",
      "dateOfLoss",
      "vin",
      "financeType",
      "accountNumber",
      "ownersName",
      "ownersPhoneNumber",
      "ownersAddress"
    ],
    optionalData: ["ownersEmailAddress"]
  },
  oneAndTheSameLetter: {
    requiredData: [
      "lenderName",
      "claimNumber",
      "causeOfLoss",
      "dateOfLoss",
      "vin",
      "financeType",
      "accountNumber",
      "ownersName",
      "ownersPhoneNumber",
      "ownersAddress"
    ],
    optionalData: ["ownersEmailAddress"]
  },
  paymentStatus: {
    requiredData: [
      "lenderName",
      "claimNumber",
      "causeOfLoss",
      "dateOfLoss",
      "vin",
      "financeType",
      "accountNumber",
      "ownersName",
      "ownersPhoneNumber",
      "ownersAddress"
    ],
    optionalData: ["ownersEmailAddress"]
  },
  w9: {
    requiredData: [
      "lenderName",
      "claimNumber",
      "causeOfLoss",
      "dateOfLoss",
      "vin",
      "financeType",
      "accountNumber",
      "ownersName",
      "ownersPhoneNumber",
      "ownersAddress"
    ],
    optionalData: ["ownersEmailAddress"]
  },
  taxExemptLetter: {
    requiredData: [
      "lenderName",
      "claimNumber",
      "causeOfLoss",
      "dateOfLoss",
      "vin",
      "financeType",
      "accountNumber",
      "ownersName",
      "ownersPhoneNumber",
      "ownersAddress"
    ],
    optionalData: ["ownersEmailAddress"]
  },
  xTitle: {
    requiredData: [
      "lenderName",
      "causeOfLoss",
      "vin",
      "titleNumber",
      "ownersName",
      "ownersPhoneNumber",
      "ownersEmailAddress",
      "ownersAddress",
      "vehicleYear",
      "damages",
      "titleBrand",
      "titleType",
      "acquiringPartyMailingAddress",
      "disposingPartyName",
      "disposingPartyAddress",
      "odometer",
      "odometerReadingDate",
      "titleTransferDate"
    ],
    optionalData: [
      "accountNumber",
      "ownersName",
      "ownersPhoneNumber",
      "ownersAddress",
      "ownersEmailAddress"
    ]
  }
};

export const defaultDocumentTypes = [
  // REQUIRED - XTITLE
  {
    label: "Title Image (Signed)",
    value: "title image signed",
    text:
      "Title Image must include both front and back of title in a single .pdf file and be endorsed by at least the buyer.",
    types: "xtitle-required-A"
  },

  // OPTIONAL - XTITLE
  {
    label: "Title Reassignment Form",
    value: "motor vehicle report",
    types: "xtitle-optional",
    link: "/documents/MV-108-CH_REASSIGNMENT-FILLABLE.pdf"
  },
  {
    label: "Odometer Disclosure",
    value: "odometer disclosure signed",
    text:
      "Follow federal odometer guidelines. Odometer disclosure document, reading, and reading date are not required if the vehicle is exempt. ",
    types: "xtitle-optional",
    link: "/documents/MV-112-CH_ODOM-FILLABLE.pdf"
  },
  {
    label: "Power of Attorney",
    value: "power of attorney",
    text:
      "May be needed for VIN reassignment. Designated POA may sign required documents. Required if the Title was signed on behalf of the owner by a third party.",
    types: "xtitle-optional",
    link: "/documents/MV-111-CH (power of attorney).pdf"
  },
  {
    label: "Lien Release (Signed)",
    value: "lien release signed",
    text:
      "Must be on lien-holder letterhead and include: VIN, current owner's name, and indicate that interest in the lien has been released.",
    types: "xtitle-optional"
  },

  // REQUIRED

  {
    label: "Settlement Breakdown",
    value: "settlement breakdown",
    text:
      "Include VIN, settlement date, and payee (including lienholder) on your company letterhead",
    types: "required"
  },
  {
    label: "Valuation Report",
    value: "valuation report",
    text:
      "Valuation Report and Settlement Breakdown must be separate documents.",
    types: "required"
  },

  // OPTIONAL

  {
    label: "Cause of Loss Statement",
    value: "cause of loss",
    text: "Required by some lenders.",
    types: "optional"
  },
  {
    label: "Police Report",
    value: "police report",
    text: "Required for theft or fire loss.",
    types: "optional"
  },
  {
    label: "Declaration Page",
    value: "declaration page",
    types: "optional"
  },
  {
    label: "Damage Estimate",
    value: "damage estimate",
    types: "optional"
  },
  {
    label: "Proof of Prior Payment",
    value: "proof of prior payment",
    types: "optional"
  },
  {
    label: "Check Image",
    value: "check image",
    types: "optional"
  },
  {
    label: "Window Sticker",
    value: "window sticker",
    types: "optional"
  },
  {
    label: "Other",
    value: "other",
    types: "optional"
  }
];

export const damageTypes = [
  {
    name: "Front",
    value: "FRONT_END"
  },
  {
    name: "Back",
    value: "BACK_END"
  },
  {
    name: "Left",
    value: "LEFT_SIDE"
  },
  {
    name: "Right",
    value: "RIGHT_SIDE"
  },
  {
    name: "Top/Roof",
    value: "TOP_ROOF"
  },
  {
    name: "Undercarriage",
    value: "UNDERCARRIAGE"
  },
  {
    name: "Fire",
    value: "FIRE"
  },
  {
    name: "Flood",
    value: "FLOOD"
  },
  {
    name: "Hail",
    value: "HAIL"
  },
  {
    name: "Wind",
    value: "WIND"
  },
  {
    name: "Fuel Contamination",
    value: "FUEL_CONTAMINATION"
  },
  {
    name: "Mechanical",
    value: "MECHANICAL"
  },
  {
    name: "Vandalism",
    value: "VANDALISM"
  },
  {
    name: "Frame",
    value: "FRAME"
  },
  {
    name: "Biohazard / Chemical",
    value: "BIOHAZARD_CHEMICAL"
  },
  {
    name: "Glass",
    value: "GLASS"
  },
  {
    name: "Electrical",
    value: "ELECTRICAL"
  },
  {
    name: "Minor Dents and Scratches",
    value: "MINOR_DENTS_AND_SCRATCHES"
  }
];

export const titleBrands = {
  paper: [
    { label: "Fire", value: "FIRE" },
    { label: "Flood", value: "FLOOD" },
    { label: "Salvage", value: "SALVAGE" },
    { label: "Cosmetic Total Loss", value: "COSMETIC_TOTAL_LOSS" },
    {
      label: "Salvage Title - Recovered Theft",
      value: "SALVAGE_RECOVERED_THEFT"
    },
    { label: "Non-Salvage Title - Recovered Theft", value: "REGULAR" }
  ],
  digital: [
    { label: "Non-Repairable (Junk)", value: "NON_REPAIRABLE" },
    {
      label: "Unrecovered Theft - Salvage Stolen",
      value: "SALVAGE_UNRECOVERED_THEFT"
    }
  ],
  mixed: [],
  nonSalvagePaper: [],
  salvagePaper: []
};

export const cosmeticEligibleDamages = [
  "HAIL",
  "VANDALISM",
  "GLASS",
  "MINOR_DENTS_AND_SCRATCHES",
  "WIND"
];

export const salvageBrands = [
  "COSMETIC_TOTAL_LOSS",
  "FIRE",
  "FLOOD",
  "SALVAGE",
  "NON_REPAIRABLE"
];

export const titleLienTypes = [
  { label: "Paper", value: "Paper" },
  { label: "Digital", value: "Digital" }
];

export const causeOfLossOptions = [
  "Single-Vehicle Collision",
  "Multi-Vehicle Collision",
  "Wind/Hail",
  "Fire",
  "Flood",
  "Vandalism",
  "Theft",
  "Other"
];

export const streetAddress2Message =
  "Street Address 2 is optional, and can contain suite, unit, or lot number.";

export const regexPatterns = {
  email: /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/,
  advancedEmail: /([-!#-'*+/-9=?A-Z^-~]+(\.[-!#-'*+/-9=?A-Z^-~]+)*|"([[\]!#-[^-~ \t]|(\\[\t -~]))+")@([0-9A-Za-z]([0-9A-Za-z-]{0,61}[0-9A-Za-z])?(\.[0-9A-Za-z]([0-9A-Za-z-]{0,61}[0-9A-Za-z])?)*|\[((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|IPv6:((((0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}):){6}|::((0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}):){5}|[0-9A-Fa-f]{0,4}::((0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}):){4}|(((0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}):)?(0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}))?::((0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}):){3}|(((0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}):){0,2}(0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}))?::((0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}):){2}|(((0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}):){0,3}(0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}))?::(0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}):|(((0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}):){0,4}(0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}))?::)((0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}):(0|[1-9A-Fa-f][0-9A-Fa-f]{0,3})|(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3})|(((0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}):){0,5}(0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}))?::(0|[1-9A-Fa-f][0-9A-Fa-f]{0,3})|(((0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}):){0,6}(0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}))?::)|(?!IPv6:)[0-9A-Za-z-]*[0-9A-Za-z]:[!-Z^-~]+)])/,
  phone: /^\+?(\d{1,3})?[-.\s]?(\(?\d{3}\)?)?[-.\s]?\d{3}[-.\s]?\d{4}(\s*(ext|x|e|e.|extension)?\s*(\d|_)+)?$/,
  vinYear: /^(19[5-9]\d|20[0-9]\d|2100)$/,
  money: /^\d+(\.\d{2})?$/
};

export const groupedOrderInitialTypes = ["letterOfGuarantee", "xTitle"];

export const groupedOrderTypes = ["letterOfGuarantee", "lienLetter", "xTitle"];
